import React, { FC, useRef, useState } from "react";
import classnames from "classnames";

import Input from "../Input";
import Icon from "../Icon";
import { IconName } from "../Icon/types";
import { IInputProps } from "../Input/types";

import "./styles.scss";

export const PasswordInput: FC<IInputProps> = ({ className, ...props }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const type = isPasswordVisible ? "text" : "password";
  const icon: IconName = isPasswordVisible ? "hide-password" : "show-password";

  const handlePasswordVisibilityChange = () => {
    setIsPasswordVisible((isVisible) => {
      return !isVisible;
    });
    inputRef.current?.focus();
  };

  return (
    <div className="ams-password-input">
      <Input
        className={classnames("ams-password-input__control", className)}
        {...props}
        ref={inputRef}
        type={type}
      />
      <button
        className="ams-password-input__icon-toggle-visibility"
        type="button"
        tabIndex={-1}
        onClick={handlePasswordVisibilityChange}
      >
        <Icon>{icon}</Icon>
      </button>
    </div>
  );
};
